// web/src/components/terms-editor.tsx
import { cn } from "@/lib/utils";

export interface TermsEditorProps {
  value: string;
  onChange(next: string): void;
  rows?: number;
  className?: string;
}

export function TermsEditor({ value, onChange, rows = 24, className }: TermsEditorProps) {
  return (
    <textarea
      className={cn(
        "w-full font-mono text-xs rounded-md border border-input bg-transparent px-3 py-2",
        "focus:outline-none focus:ring-1 focus:ring-ring",
        className,
      )}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={rows}
      aria-label="Terms template text"
    />
  );
}
